export default "__VITE_ASSET__ou1v9HNx__"